import { FaSearch } from 'react-icons/fa';
import {
  CERTIFICATES_TYPES,
  CERTIFICATES_OPTIONS,
  CERTIFICATES_PLACEHOLDER,
  CERTIFICATES_TYPES_TRANSLATED,
} from '../../../../interaces/certificates_types.interface';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { justNumbersAndLetters, numbersAndLettersAndGuion } from '../../../../services/helpers';
import styles from "../../styles/EmissionSearch.module.css"
function EmissionSearch({
  searchData,
  setSearchData,
  searchQuery,
  setSearchQuery,
  onSearch,
  loading,
  setSearchResult,
}) {
  const [maxLength, setMaxLength] = useState(100);
  const [lastType, setLastType] = useState(1);
  const [isOkey, setIsOkey] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isOkey && !loading) {
      onSearch();
    }
  };

  useEffect(() => {
    setSearchData((prev) => ({
      ...prev,
      option: '',
      value: '',
    }));
    setIsOkey(false);
    setSearchResult(null);
  }, [searchData.type]);

  useEffect(() => {
    setSearchData((prev) => ({
      ...prev,
      value: '',
    }));
    setIsOkey(false);
    setSearchResult(null);
  }, [searchData.option]);
  useEffect(() => {
    setSearchResult(null);
  }, [searchData.value]);
  const rules = (e) => {
    let ok = false;

    if (searchData.option === 'curp') {
      justNumbersAndLetters(e);
      const val = e.target.value.trim();
      ok = val.length === 18;
      setMaxLength(18);
    } else if (searchData.option === 'rfc') {
      justNumbersAndLetters(e);
      const val = e.target.value.trim();
      ok = val.length === 12 || val.length === 13;
      setMaxLength(13);
    } else if (searchData.option === 'claveCatastral') {
      numbersAndLettersAndGuion(e);
      const val = e.target.value.trim();
      ok = val.length >= 4 && val.length <= 30;
      setMaxLength(30);
    } else if (searchData.option === 'folioRegistral') {
      numbersAndLettersAndGuion(e);
      const val = e.target.value.trim();
      ok = val.length >= 4 && val.length <= 30;
      setMaxLength(30);
    } else if (searchData.option === 'folioMercantil') {
      numbersAndLettersAndGuion(e);
      const val = e.target.value.trim();
      ok = val.length >= 4 && val.length <= 30;
      setMaxLength(30);
    } else {
      ok = e.target.value.trim().length > 0;
    }

    setIsOkey(ok);
    setSearchData((prev) => ({
      ...prev,
      value: e.target.value,
    }));
  };

  const certificateOptions = Object.entries(CERTIFICATES_TYPES || {}).map(([key, value]) => ({
    key,
    value,
  }));

  const searchOptions = Object.entries(CERTIFICATES_OPTIONS[searchData.type] || {}).map(
    ([key, value]) => ({
      label: key,
      option: value,
    })
  );

  return (
  <div className={styles.emisionSearchShell}>
    <h3 className={styles.emisionSearchTitle}>Datos de búsqueda</h3>

    <div className={styles.emisionSearchRow}>
      {/* CERTIFICADO */}
      <div className={styles.emisionSearchField}>
        <label className={styles.emisionSearchLabel}>
          <span className={styles.emisionSearchLabelText}>
            Certificado:
          </span>
        </label>

        <div className={styles.emisionSearchSelect}>
          <Select
            options={certificateOptions}
            getOptionLabel={(option) => option.key}
            getOptionValue={(option) => option.value}
            value={
              certificateOptions.find(
                (option) => option.value === searchData.type
              ) || null
            }
            onChange={(opcion) => {
              setLastType(lastType + 1);

              setSearchData({
                ...searchData,
                type: opcion.value,
                option: '',
                value: '',
                type_translated:
                  CERTIFICATES_TYPES_TRANSLATED[opcion.value] || '',
              });
            }}
            placeholder="Tipo de certificado"
            isSearchable={false}
          />
        </div>
      </div>

      {/* BUSCAR POR */}
      <div className={styles.emisionSearchField}>
        <label className={styles.emisionSearchLabel}>
          <span className={styles.emisionSearchLabelText}>
            Buscar por:
          </span>
        </label>

        <div className={styles.emisionSearchSelect}>
          <Select
            isDisabled={!searchData.type}
            className={styles.emisionSearchSelectControl}
            options={searchOptions}
            value={
              searchOptions.find(
                (option) => option.option === searchData.option
              ) || null
            }
            onChange={(opcion) => {
              setSearchData({
                ...searchData,
                option: opcion.option,
                value: '',
              });
            }}
            placeholder="Elige una opción"
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.option}
          />
        </div>
      </div>
    </div>

    <div className={styles.emisionSearchActions}>
      <div className={styles.emisionSearchInputField}>
        <label className={styles.emisionSearchLabel}>
          <span className={styles.emisionSearchLabelText}>
            Ingresa el dato:
          </span>
        </label>

        <input
          disabled={
            searchData.type === '' || searchData.option === ''
          }
          maxLength={maxLength}
          type="text"
          placeholder={
            searchData.type
              ? searchData.option
                ? CERTIFICATES_PLACEHOLDER[searchData.option]
                : 'Elige la opción de búsqueda'
              : 'Elige el tipo de búsqueda'
          }
          value={searchData.value}
          onChange={(e) => rules(e)}
          onKeyDown={handleKeyDown}
          className={styles.emisionSearchInput}
        />
      </div>

      <button
        type="button"
        disabled={
          searchData.type === '' ||
          searchData.option === '' ||
          searchData.value === '' ||
          loading ||
          !isOkey
        }
        onClick={onSearch}
        className={styles.emisionSearchButton}
      >
        <FaSearch />
        {loading ? 'Consultando..' : 'Consultar'}
      </button>
    </div>
  </div>
);
}

export default EmissionSearch;
